export default "__VITE_ASSET__DpabetbL__"